module.exports = __webpack_public_path__ + "static/media/PORTADA.a9e9b570.jpg";